import React from "react"
import { Box } from "@mui/material"
import IconButton from "@mui/material/IconButton"
import CloseIcon from "@mui/icons-material/Close"
import styles from "./ButtonClose.module.scss"
/**
 * 閉じるボタン
 */
const ButtonClose = () => {
  return (
    <Box className={styles.closeWrapper}>
      <IconButton
        className={styles.buttonClose}
        onClick={() => {
          window.close()
        }}
      >
        <CloseIcon />
        閉じる
      </IconButton>
    </Box>
  )
}

export default ButtonClose
